import React, { useMemo } from 'react';

import BaseSelector from './BaseSelector';

const CorporateSelector = ({ filter, ...props }) => {
  const { operator, name } = filter;
  const config = useMemo(() => {
    return {
      name,
      url: 'corporates/?q=',
      valueKey: 'id',
      labelKey: 'name',
    };
  }, [name]);

  const onChange = value => {
    props.onChange({
      value,
      operator,
      name,
    });
  };

  return (
    <>
      <div>Corporations</div>
      <BaseSelector filter={filter} config={config} onChange={onChange} />
    </>
  );
};
export default CorporateSelector;
